import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import NavigationBar from "../components/NavigationBar.js";
import MainSection from "../components/MainSection.js";
import seriesStore from "../stores/seriesStore.js";
import statusStore from "../stores/statusStore.js";
import seasonStore from "../stores/seasonStore.js"
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import SeriesInfo from "../components/SeriesInfo.js";


export default function SeriesPage() {
    const location = useLocation();
    
    const serStore = seriesStore();
    const staStore = statusStore();
    const seaStore = seasonStore();

    const [selectedShow, setSelectedShow] = useState(null);
    const [selectedSeriesList, setSelectedSeriesList] = useState(null);
    const [activeHeader, setActiveHeader] = useState(false);

    const [navOpen, setNavOpen] = useState(null);

    // Runs the function on load
    useEffect(() => {
        serStore.fetchSeries();
        staStore.fetchStatus();
        seaStore.fetchSeason();
    }, []);

    useEffect(() => {
        if (!selectedShow?._id) return;
    }, [selectedShow?._id, staStore.status]);

    useEffect(() => {
        if (location.state?.selectedShow) {
            setSelectedShow(location.state.selectedShow);
            console.log("selected show = " + selectedShow?.title);
        }
    }, [location.state]);

    return (
        <div className="app-wrapper tv-static">
            <header class="header">
                <Header 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                />
            </header>
            <content className="content">
                <nav className="nav">
                    <NavigationBar 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                    />
                </nav>
                <main className="main">
                    {/* <MainSection 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                    /> */}
                    {selectedShow ? (
                        <SeriesInfo 
                        selectedShow={selectedShow}
                        setSelectedShow={setSelectedShow}
                    />
                    ): ""}
                </main>
                <aside className="right">
                    <div className="rightPanel">
                    </div>
                </aside>
            </content>
            <div class="footer"><Footer/></div>
        </div>
    )
}